import React from 'react';
import { FadeIn } from './FadeIn';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Observás',
    desc: 'Aprendés a reconocer el momento justo en que tu bebé está listo para dormir, usando el mapa de ventanas de sueño.'
  }, {
    num: '2',
    title: 'Acompañás',
    desc: 'Aplicás la técnica del Ancla Invisible durante 3 noches, acompañando a tu bebé de forma gradual y amorosa.'
  }, {
    num: '3',
    title: 'Descansás',
    desc: 'Tu bebé empieza a enlazar mejor sus ciclos de sueño y vos volvés a dormir de corrido. Sin magia, con constancia.'
  }];
  return <section className="bg-cream py-24 px-6 md:px-12" data-id="element-75">
      <div className="max-w-5xl mx-auto" data-id="element-76">
        <FadeIn data-id="element-77">
          <h2 className="text-4xl md:text-5xl text-center mb-16" data-id="element-78">
            3 Pasos Simples
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-79">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-periwinkle/20 z-0" data-id="element-80"></div>

          {steps.map((step, index) => <FadeIn key={index} delay={0.2 * index} className="relative z-10" data-id="element-81">
              <div className="flex flex-col items-center text-center" data-id="element-82">
                <div className="w-24 h-24 bg-periwinkle text-cream rounded-full flex items-center justify-center text-4xl font-serif mb-6 shadow-lg border-4 border-cream" data-id="element-83">
                  {step.num}
                </div>
                <h3 className="text-2xl font-bold mb-3" data-id="element-84">{step.title}</h3>
                <p className="text-lg text-brown/80" data-id="element-85">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}